<template>
  <div class="fold-menu-container" :style="{ gap }">
    <div class="submenu" v-for="section in menu" :key="section.label">
      <a class="lg-font" v-if="section.link" :href="section.link" :target="section.target">
        {{ $t(section.label) }}
      </a>
      <template v-else>
        <span class="lg-font submenu-title" @click="toggleActiveMenu(section.label)">
          <span>{{ $t(section.label) }}</span>
          <span>{{ activeMenu === section.label ? '-' : '+' }}</span>
        </span>
        <div class="submenu-item-container" v-show="activeMenu === section.label">
          <a class="sm-font" v-for="item in section.children" :key="item.label" :href="item.link" :target="item.target">
            {{ $t(item.label) }}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    gap: {
      type: String,
      default: "80px"
    }
  },
  data() {
    return {
      activeMenu: ""
    }
  },
  methods: {
    toggleActiveMenu(label) {
      if (this.activeMenu === label) {
        this.activeMenu = ''
      } else {
        this.activeMenu = label
      }
    }
  }
}
</script>

<style scoped>
.fold-menu-container {
  background-color: #051432;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.submenu {
  width: 100%;
  text-align: left;
}
.lg-font {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
}
.submenu-title {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.submenu-item-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}
.sm-font {
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  line-height: 19px;
}
</style>